import { render } from "./ComponentAccount.vue?vue&type=template&id=0e459947&scoped=true"
import script from "./ComponentAccount.vue?vue&type=script&lang=js"
export * from "./ComponentAccount.vue?vue&type=script&lang=js"

import "./ComponentAccount.vue?vue&type=style&index=0&id=0e459947&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e459947"]])

export default __exports__